module.exports = __webpack_public_path__ + "static/img/4.858d3e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/4.png
// module id = AwAS
// module chunks = 35